import * as EmployeeGen from '../../store/generated/portal/employee';

// Tag types for employee operations
export const EmployeeApiTags = {
  Employee: 'Employee',
  Employees: 'Employees',
  EmployeeRole: 'EmployeeRole',
  EmployeeAssignment: 'EmployeeAssignment',
  EmployeeRecord: 'EmployeeRecord',
  EmployeeCategory: 'EmployeeCategory',
  EmployeeImport: 'EmployeeImport',
} as const;

// Re-export the generated hooks with better names
export const {
  useApiPortalV1EmployeeEmployeesCreateMutation: useCreateEmployeeMutation,
  useApiPortalV1EmployeeEmployeesRetrieveQuery: useGetEmployeeQuery,
  useApiPortalV1EmployeeEmployeesPartialUpdateMutation: useUpdateEmployeeMutation,
  useApiPortalV1EmployeeEmployeesToggleStatusCreateMutation: useToggleEmployeeStatusMutation,
  useApiPortalV1EmployeeEmployeesDemographicFieldsRetrieveQuery: useGetDemographicFieldsQuery,
  useApiPortalV1EmployeeEmployeesOrganizationEmployeesRetrieveQuery:
    useGetOrganizationEmployeesQuery,
  useApiPortalV1EmployeeImportExportRetrieveQuery: useExportEmployeesQuery,
  useApiPortalV1EmployeeImportImportCreateMutation: useImportEmployeesMutation,
  useApiPortalV1EmployeeImportImportRecordsCreateMutation: useImportEmployeeRecordsMutation,
  useApiPortalV1EmployeeImportRecordTemplateRetrieveQuery: useGetRecordTemplateQuery,
  useApiPortalV1EmployeeImportTemplateRetrieveQuery: useGetImportTemplateQuery,
} = EmployeeGen;
